/**
 * Iter 743 — media moved Cloudinary → Bunny.net (allsale.b-cdn.net).
 * Bunny Optimizer resizes via query params (?width=&quality=…); the old
 * Cloudinary path-transform stays only as a fallback for the few weeks
 * Cloudinary remains readable, then it gets cancelled.
 */

/** Generic variant: card 320/gallery 800/full 1600, OG 1200. */
export const imgVariant = (url, w, q = 75) => {
  if (!url) return url;
  if (url.includes("allsale.b-cdn.net") && !url.includes("?")) {
    return `${url}?width=${w}&quality=${q}`;
  }
  return url;
};

/** Square circle-tile crop (2× for retina, used by the category circles). */
export default function tileSrc(url, px = 320) {
  if (!url) return url;
  if (url.includes("allsale.b-cdn.net")) {
    return url.includes("?")
      ? url
      : `${url}?width=${px}&height=${px}&aspect_ratio=1:1&quality=75`;
  }
  // Cloudinary fallback window (Iter 712 behaviour).
  if (url.includes("/image/upload/")) {
    return url.replace(
      "/image/upload/",
      `/image/upload/c_fill,w_${px},h_${px},q_auto,f_auto/`,
    );
  }
  return url;
}
